import "./Branding.css"

type BrandingProps = {
}


export const Branding = ({} : BrandingProps) => {
    return (
        <div 
            className="branding"
            onClick={() => window.open("https://effno.co", "_blank")}
        >
            Powered by&nbsp;<b>effno</b>
        </div>
    )
}